import SearchResultsSidebar from './mapSearchResultsSidebar';
import MapsContainer from './mapsContainer';
import PlaceDetails from './place-details';
import StormReport from './storm-report';
import MapDetails from './map-details';
import DownloadedMapList from './downloadedMapsList';
import SwathDetails from './swath-details';
import MapList from './map-list';
import MapListItem from './map-list-item';
import MapSearchList from './map-search-list';
import ImpactMapList from './impact-map-list';
import Legend from './legend';

var Maps = {
	SearchResultsSidebar,
	MapsContainer,
  PlaceDetails,
  StormReport,
  DownloadedMapList,
  SwathDetails,
}

export default Maps;
export {
  Map,
  SearchResultsSidebar,
  MapsContainer,
  PlaceDetails,
  StormReport,
  MapDetails,
  DownloadedMapList,
  SwathDetails,
	MapList,
	MapListItem,
	MapSearchList,
	ImpactMapList,
	Legend
};



// WEBPACK FOOTER //
// ./src/browser/components/maps/index.js